import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

import * as ROUTES from "../../../constant/routes";

const TutorialNav = (props) => {
	const [show, setShow] = useState(false);

	return (
		<>
			<div className="tutorial-sidebar isOff1199">
				<div className="line" />
				<NavLink to={ROUTES.HOW_IT_WORK} activeClassName="active" className="tutorial-sidebar--item">
					Hướng dẫn chung
				</NavLink>
				{/* <div className="line" />
				<NavLink to={ROUTES.OWNER_GUIDE} activeClassName="active" className="tutorial-sidebar--item">
					Hướng dẫn cho chủ xe
				</NavLink> */}
				<div className="line" />
				<NavLink to={ROUTES.BOOKING_HOW_TO} activeClassName="active" className="tutorial-sidebar--item">
					Hướng dẫn đặt xe
				</NavLink>
				<div className="line" />
				<NavLink to={ROUTES.PAYMENT_HOW_TO} activeClassName="active" className="tutorial-sidebar--item">
					Hướng dẫn thanh toán
				</NavLink>
				<div className="line" />
				<NavLink to={ROUTES.REGU} activeClassName="active" className="tutorial-sidebar--item">
					Quy chế hoạt động
				</NavLink>
				<div className="line" />
			</div>
			<div className="tutorial-dropdown isShow1199">
				<div className="custom-dropdown" onClick={() => setShow(!show)}>
					<div className={`dropdown-selected ${show ? "selected" : ""}`}>{props.active}</div>
					{show && (
						<div className="dropdown-option">
							<Link to={props.isMobile ? ROUTES.M_HOW_IT_WORK : ROUTES.HOW_IT_WORK} className="dropdown-option__item">
								<p className="text">Hướng dẫn chung</p>
							</Link>
							{/* <Link to={props.isMobile ? ROUTES.M_OWNER_GUIDE : ROUTES.OWNER_GUIDE} className="dropdown-option__item">
								<p className="text">Hướng dẫn cho chủ xe </p>
							</Link> */}
							<Link
								to={props.isMobile ? ROUTES.M_BOOKING_HOW_TO : ROUTES.BOOKING_HOW_TO}
								className="dropdown-option__item">
								<p className="text">Hướng dẫn đặt xe</p>
							</Link>
							<Link
								to={props.isMobile ? ROUTES.M_PAYMENT_HOW_TO : ROUTES.PAYMENT_HOW_TO}
								className="dropdown-option__item">
								<p className="text">Hướng dẫn thanh toán</p>
							</Link>
							<Link to={props.isMobile ? ROUTES.M_REGU : ROUTES.REGU} className="dropdown-option__item">
								<p className="text">Quy chế hoạt động</p>
							</Link>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default TutorialNav;
